
define('text!_templates/fans.html',[],function () { return '\n<div class="x xw box bs-container-grid" data-section="fans" data-fans></div>\n\n<div class="x xw box bs-container-grid" data-section="fan-of" data-fans-of></div>';});

